export enum PlatformMessageType {
    OMG = 1,
    TOASTER = 2,
    KICK = 3,
    INIT_GEO = 9,
    UPDATE_RESTRICTION_V2 = 10,
    BET_REJECTED = 12,
    PROMOTION_DISPLAY_IN_CLIENT = 13,
    TIME_BASE_PROMOTION_ELIGIBILITY_CHECK = 14,
    FREE_TO_PLAY_ELIGIBILITY_CHECK = 15,
    INTRUSIVE_MESSAGE = 16, // for example, UKGC initial warning message or BIG WIN message
    GAMBLING_SESSION_ACTION = 17,
}
